// extracted by mini-css-extract-plugin
module.exports = {"sort":"styles_sort__2ZGzz","button":"styles_button__2tSH4","button_active":"styles_button_active__2Ut7E","arrow":"styles_arrow__2O_Kc"};